export default {
      id: "color_bacteria_caterpillar-usage",
      viewBox: "0 0 288 378",
      url: __webpack_public_path__ + "sprite.svg#color_bacteria_caterpillar",
      toString: function () {
        return this.url;
      }
    }